import { render } from "./Jobs.vue?vue&type=template&id=60bfd54e"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"
script.render = render

export default script